var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-animate overflow-hidden",style:({transition: `max-height ${_vm.speed}ms`, maxHeight: _vm.expanded ? `${_vm.bodyHt}px` : 0})},[_c('div',{ref:"body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }